import { action, makeObservable, observable } from 'mobx';
import { IMonthlyOrder, ISelectList } from '../interfaces';

export class MonthlyOrderStore {
    private constructor() {
        makeObservable(this);
    }

    private static instance: MonthlyOrderStore;
    public static getInstance(): MonthlyOrderStore {
        if (!MonthlyOrderStore.instance) {
            MonthlyOrderStore.instance = new MonthlyOrderStore();
        }
        return MonthlyOrderStore.instance;
    }

    initStore: IMonthlyOrder = {
        id: 0,
    };

    @observable order: IMonthlyOrder = this.initStore;
    @action setOrder(order: IMonthlyOrder): void {
        this.order = order;
    }

    @observable availableOrdersSelect: ISelectList = [];

    @action setOrderAvailableOrdersSelect(list: ISelectList): void {
        this.availableOrdersSelect = list;
    }

    @action cleanStore(): void {
        this.order = this.initStore;
        this.availableOrdersSelect = [];
    }
}
